module.exports = __webpack_public_path__ + "static/media/BG.15f4b855.jpg";